import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { formatDate, formatMoney } from "../Helpers";

export default function View({ data }) {

	const appContext = useContext(AppContext);

	/* Place states here */

	function manageStudents() {
		appContext.navTo({
			item: 'view',
			subItem: 'classroom-students',
			extraItem: data.uuid,
		})
	}

	function manageClassroom() {
		appContext.navTo({
			item: 'view',
			subItem: 'classroom-options',
			extraItem: data.uuid,
		})
	}

	return (
		<div className="One" >
			<div className="row">

				<div className="col-12">
					<h6
						style={{
							fontSize: "14px"
						}}
						className="font-semi-bold"
					>
						{data.name}
					</h6>
				</div>
				
				<div className="col-12 text-end">
					<button
						className="btn btn-sm btn-outline-dark m-1"
						onClick={manageStudents}
					>
						Manage Students
					</button>

					<button
						className="btn btn-sm btn-outline-primary m-1"
						onClick={manageClassroom}
					>
						Manage Classroom
					</button>

				</div>

			</div>
		</div>
	)

}